import { render, staticRenderFns } from "./AreaIcrea.vue?vue&type=template&id=0d0e3d08&"
import script from "./AreaIcrea.vue?vue&type=script&lang=js&"
export * from "./AreaIcrea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports